// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-all-item {
  background-color: #f8f9fa !important;
}

.partner-selected {
  border-left: 4px solid #28a745 !important;
}

.partner-pending {
  border-left: 4px solid #ffc107 !important;
}

.partner-none {
  border-left: 4px solid #dc3545 !important;
}`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/budgetModal.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".select-all-item {\n  background-color: #f8f9fa !important;\n}\n\n.partner-selected {\n  border-left: 4px solid #28a745 !important;\n}\n\n.partner-pending {\n  border-left: 4px solid #ffc107 !important;\n}\n\n.partner-none {\n  border-left: 4px solid #dc3545 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
